import { render } from "./Routers.vue?vue&type=template&id=159cedf3"
import script from "./Routers.vue?vue&type=script&lang=js"
export * from "./Routers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__